import DataTable from 'datatables.net-react';
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import * as BullCache from "../../util/BullCache";
import "../custom.css";
import { AdminService } from '../../services/AdminService';
import { Col, Row } from 'react-bootstrap';
import AdminDropdown from '../components/AdminDropdown';
import MasterDropdown from '../components/MasterDropdown';
import SuperMasterDropdown from '../components/SuperMasterDropdown';
import BrokerDropdown from '../components/BrokerDropdown';


function AdminLoginHistory() {

  const [loading, setLoading] = useState(false);
  const [userlist, setUserlist] = useState([]);

  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [selectedBrokerId, setSelectedBrokerId] = useState(null);
  const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);  

  var user = BullCache.getFromCache("user");
  function getCustomers() {
    setUserlist([]);
    var adminId;
    
    if (selectedBrokerId != null) {
      adminId = selectedBrokerId;
    } else if (selectedMaster) {
      adminId = selectedMaster.value;
    } else if (selectedAdmin) {
      adminId = selectedAdmin.value;
    }  

    if(adminId && selectedDate) {
      setLoading(true);
      AdminService.getAdminLoginHistory({ 'loginId': user.adminId, 'adminId': adminId,  date: selectedDate }).then(resp => {
          setLoading(false);
          if (resp.code === 1) {
            if (resp.data.loginHistory.length > 0) {
              setUserlist(resp.data.loginHistory);
            } 
          }
        });
    }
  }

  const handleSubmit = () => {
     getCustomers();
  };

  const handleDateChange = (e) => {
      setSelectedDate(e.target.value);
  };


  const columns = [
     {
    title: 'Index',
    data: null,
    render: (data, type, full, meta) => meta.row + 1, // row number (1-based)
    visible: false,  // Hides the column from UI
  },
    {
      title: 'LOGIN/LOGOUT', className: 'col-1 font-bold text-nowrap fss-09', render: (data, type, full, meta) => {
        if (type === 'display') {
          if (full.loginTime != null) {
            return `<span style="background-color:green; color:white; padding:2px 6px; border-radius:4px;">LOGIN</span>`;
          } else if (full.logoutTime != null) {
            return `<span style="background-color:red; color:white; padding:2px 6px; border-radius:4px;">LOGOUT</span>`;
          }
        }
        return '';
      }, 
    },
    {
      title: 'TIME', className: 'col-2 font-bold text-nowrap fss-09', render: (data, type, full, meta) => (full.loginTime != null ? full.loginTime : full.logoutTime), 
    },
    { title: 'DEVICE',  data: 'device', className: 'col-2 font-bold fss-09'},
    {
      title: 'IP Address', data: 'ip', className: 'col-2 font-bold text-nowrap fss-09'
    },
     
  
  ];

  return (
    <div className='container-fluid mb-5'>
        <Row className='mb-2'>
            {(user.adminType === "SUPER_ADMIN" || user.adminType == 'SUPER_MASTER') && (
                  <Col xs={4} xl={2}>
                    <b className="fss-05">SUPER MASTER</b>
                    <SuperMasterDropdown
                      adminId={user.adminId}
                      setSelectedOption={setSelectedAdmin}
                    />
                  </Col>
                )}

               {(user.adminType === "SUPER_ADMIN" || user.adminType == 'SUPER_MASTER') && (
                  <Col xs={4} xl={2}>
                    <b className="fss-05">ADMIN</b>
                    <AdminDropdown
                      adminId={user.adminId}
                      setSelectedOption={setSelectedAdmin}
                    />
                  </Col>
                )}

                {(user.adminType === "SUPER_ADMIN" ||
                  user.adminType === "ADMIN" || user.adminType == 'SUPER_MASTER' ) && (
                  <Col xs={4} xl={2}>
                    <b className="fss-05">MASTER</b>
                    <MasterDropdown
                      adminId={user.adminId}
                      selectedAdmin={selectedAdmin}
                      setSelectedOption={setSelectedMaster}
                      setSelectedMaster={setSelectedMaster}
                      setSelectedBrokerId={setSelectedBrokerId}
                    />
                  </Col>
                )}

            {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'MASTER' || user.adminType == 'SUPER_MASTER' ?
              <>
                <Col>
                  <b className="fss-05">BROKER</b>
                  <BrokerDropdown
                    selectedAdmin={selectedAdmin}
                    selectedMaster={selectedMaster}
                    setSelectedOption={setSelectedBrokerId}
                    setSelectedBrokerId={setSelectedBrokerId}
                    setSelectedSubBrokerId={setSelectedSubBrokerId}
                  //onChange={handleSelectedBrokerChange}
                  />
                </Col>
              </> : ""}


                 <Col xs={4} xl={2}>
                   <input type="date" className='bg-light text-black form-control' style={{marginTop:"10%"}} value={selectedDate}
                            onChange={handleDateChange} defaultValue={new Date().toISOString().split('T')[0]}
                        />
                  </Col>      
        <Col className='pt-3'>
        <Button variant="success" size="sm" className='mt-2 mb-1' onClick={handleSubmit}>
                    <b className="fss-08" >SUBMIT</b>
        </Button>
        </Col>
      </Row>
      <Card className='mt-1 ' >
        <Card.Body className='ps-0 pe-0'>
        <div className="table-responsive">
            {loading ? (
              <div className="container vh-100">
                <div className="d-flex align-items-center justify-content-center h-90">
                  <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            ) : 
              <DataTable id="table" className="mt-1 table table-striped bg-secondary-row fss-09"
                data={userlist} columns={columns}
                options={{
                order: [[0, 'asc']], 
                pageLength: 50,
                columnDefs: [
                  { targets: [ 1, 2, 3, 4], orderable: false } // disable sorting on all except TIME
                ]
              }}
              />
            }
          </div>

        </Card.Body>
      </Card>

     

    </div>
  )

}

export default AdminLoginHistory;